import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function OsintCTA() {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 bg-white" id='ctaOsint'>
      {/* Container élargi pour un impact maximal */}
      <div className="max-w-[1000px] mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-[2.5rem] bg-[#163354] p-12 md:p-16 text-center shadow-2xl"
        >
          {/* 1. L'effet "Poussière de couleur" (Grain/Noise) */}
          <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay pointer-events-none">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <filter id="noiseFilter">
                <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch"/>
              </filter>
              <rect width="100%" height="100%" filter="url(#noiseFilter)"/>
            </svg>
          </div>

          {/* 2. Dégradés radiaux (Dust of color) */}
          <div className="absolute top-[-10%] left-[-5%] w-[70%] h-[120%] bg-blue-400/10 blur-[100px] rounded-full pointer-events-none" />
          <div className="absolute bottom-[-20%] right-[-5%] w-[50%] h-[100%] bg-white/5 blur-[80px] rounded-full pointer-events-none" />

          {/* Contenu */}
          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-white text-3xl md:text-4xl font-black mb-6 tracking-tight leading-tight">
              Prêt à analyser votre présence visuel ?
            </h2>
            
            {/* Box textuelle avec Backdrop Blur (Glass effect) */}
            <div className="bg-[#1e446e]/40 backdrop-blur-md rounded-2xl p-7 mb-10 border border-white/10">
              <p className="text-blue-100/90 text-[15px] font-medium leading-relaxed">
                Nos experts sont à votre disposition pour une première évaluation gratuite de vos besoins en renseignement.
              </p>
            </div>

            <motion.button
              onClick={() => navigate('/rdv')}
              whileHover={{ 
                scale: 1.03,
                backgroundColor: "#ffffff",
                boxShadow: "0 15px 35px rgba(0,0,0,0.2)"
              }}
              whileTap={{ scale: 0.98 }}
              className="bg-white text-[#3b82f6] px-10 py-4 rounded-xl font-black text-[13px] uppercase tracking-[0.2em] transition-all duration-300"
            >
              Démarrer l'audit
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
